import {
  Button,
  Colors,
  Cross,
  Modal,
  NavigationIcon,
  NavigationNotification,
  StatusBox,
  StatusBoxWrap,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import styles from './style.module.scss'
interface IState {}

interface IProps {
  open: boolean
  onSubmit: () => void
  onClose: () => void
  gamesCount: number
  questionnairesCount: number
  goToQuestionnaires: () => void
  goToGames: () => void
}

export class TempEvalStatusModal extends React.Component<IProps, IState> {
  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
      // window.history.back()

      onClose()
    }
  }

  render() {
    const { onSubmit, open, gamesCount, questionnairesCount } = this.props

    return (
      <Modal
        active={open}
        setActive={this.setActive}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography type="title" size="big">
          Evaluation Status{' '}
        </Typography>
        <Typography type="text">
          {questionnairesCount > 0 && gamesCount > 0
            ? `You have ${questionnairesCount} questionnaires and ${gamesCount} games left to complete`
            : questionnairesCount > 0
            ? `You have ${questionnairesCount} unfinished questionnaires`
            : `You have ${gamesCount} games left to complete`}
        </Typography>
        <StatusBoxWrap>
          {questionnairesCount > 0 && (
            <StatusBox
              onClick={() =>
                questionnairesCount !== 0 && this.props.goToQuestionnaires()
              }
              icon={<NavigationIcon type="Questionnaires" active={true} />}
              statusIcon={
                <NavigationNotification number={questionnairesCount} />
              }
            />
          )}
          {gamesCount > 0 && (
            <StatusBox
              onClick={() => {
                if (gamesCount !== 0) {
                  this.props.goToGames()
                }
              }}
              icon={<NavigationIcon type="Games" active={true} />}
              statusIcon={<NavigationNotification number={gamesCount} />}
            />
          )}
        </StatusBoxWrap>
        <Button color="pink" onClick={onSubmit}>
          Take Tour
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TempEvalStatusModal/index.tsx